<template>
  <div class="information">
    <div class="information-inputs">
      <InputWrapper title="Название площадки">
        <BaseInput v-model="form.title" />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.title.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Стоимость (полчаса)">
        <BaseInput
          v-model="form.price"
          type="number"
          class="information-inputs__price"
        />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.price.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Телефон">
        <BaseInput
          v-mask="phoneMask"
          v-model="form.phone"
        />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.phone.required.$invalid">
          {{ errorText.required }}
        </InvalidFeedback>
        <InvalidFeedback v-if="v$.form.$dirty && v$.vuexValues.phone.isCorrectly.$invalid">
          {{ errorText.phone }}
        </InvalidFeedback>
      </InputWrapper>
    </div>

    <InputWrapper title="Дополнительно">
      <div class="radio-wrappers">
        <RadioWrapper class="radio-wrappers__item" title="Покрытие">
          <BaseRadio
            v-for="(item, index) of options.coating"
            :key="index"
            v-model="form.coating"
            :value="item.value"
            :label="item.text"
          />
        </RadioWrapper>
        <RadioWrapper class="radio-wrappers__item" title="Шипованные бутсы">
          <BaseRadio
            v-for="(item, index) of options.studdedCleats"
            :key="index"
            v-model="form.studdedCleats"
            :value="item.value"
            :label="item.text"
          />
        </RadioWrapper>
        <RadioWrapper class="radio-wrappers__item" title="Оплата переводом">
          <BaseRadio
            v-for="(item, index) of options.paymentTransfer"
            :key="index"
            v-model="form.paymentTransfer"
            :value="item.value"
            :label="item.text"
          />
        </RadioWrapper>
      </div>
    </InputWrapper>

    <InputWrapper title="Оснащение поля">
      <div class="radio-wrappers">
        <div
          v-for="(item, index) of fieldEquipment"
          :key="index"
        >
          <RadioWrapper class="radio-wrappers__item" :title="item.title">
            <BaseRadio
              v-for="(option, index) of options.paid"
              :key="index"
              v-model="form[item.propName].radio"
              :value="option.value"
              :label="option.text"
            />

            <BaseInput
              v-if="form[item.propName].radio === 'paid'"
              v-model="form[item.propName].price"
              type="number"
              class="price-input"
              placeholder="Цена"
            />
          </RadioWrapper>
        </div>
      </div>
    </InputWrapper>

    <div class="panel">
      <BaseButton @click="onSave">
        Сохранить
      </BaseButton>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { phoneMask } from '@/constants'
import { parsePhone } from '@/utils/functions'

import InputWrapper from '@/components/InputWrapper'
import BaseInput from '@/components/Base/BaseInput'
import InvalidFeedback from '@/components/InvalidFeedback'
import RadioWrapper from '@/components/RadioWrapper'
import BaseRadio from '@/components/Base/BaseRadio'
import BaseButton from '@/components/Base/BaseButton'

export default {
  name: 'AppInformation',
  components: {
    BaseButton,
    BaseRadio,
    RadioWrapper,
    InvalidFeedback,
    BaseInput,
    InputWrapper
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      phoneMask,
      options: {
        coating: [
          { value: 0, text: 'Асфальт' },
          { value: 1, text: 'Поле (натуральное)' },
          { value: 2, text: 'Поле (искусственое)' }
        ],
        studdedCleats: [
          { value: true, text: 'Можно' },
          { value: false, text: 'Нельзя' }
        ],
        paymentTransfer: [
          { value: true, text: 'Можно' },
          { value: false, text: 'Нельзя' }
        ],
        paid: [
          { value: false, text: 'Нет' },
          { value: true, text: 'Есть' },
          { value: 'paid', text: 'Есть платное' }
        ]
      },
      fieldEquipment: [
        {
          title: 'Мячи',
          propName: 'balls'
        },
        {
          title: 'Освещение',
          propName: 'lighting'
        },
        {
          title: 'Душевые',
          propName: 'showers'
        },
        {
          title: 'Раздевалки',
          propName: 'changingRooms'
        },
        {
          title: 'Манишки',
          propName: 'manishki'
        }
      ],
      form: {
        title: null,
        price: null,
        phone: null,
        coating: null,
        studdedCleats: null,
        paymentTransfer: null,
        balls: {
          radio: null,
          price: null
        },
        lighting: {
          radio: null,
          price: null
        },
        showers: {
          radio: null,
          price: null
        },
        changingRooms: {
          radio: null,
          price: null
        },
        manishki: {
          radio: null,
          price: null
        }
      }
    }
  },
  computed: {
    errorText () {
      return this.$store.state.errors.inputErrors
    },
    requestBody () {
      const getValueWhereExistsPaidOption = (propName) => {
        if (typeof this.form[propName].radio === 'boolean') {
          if (this.form[propName].radio) {
            return 'yes'
          } else {
            return 'no'
          }
        } else {
          return this.form[propName].price
        }
      }

      return {
        id: this.$route.params.id,
        title: this.form.title,
        price: this.form.price,
        phone: parsePhone(this.form.phone),
        coating: Number(this.form.coating),
        studdedCleats: this.form.studdedCleats,
        paymentByTransfer: this.form.paymentTransfer,
        fieldSize: {
          length: 10,
          width: 10
        },
        ball: getValueWhereExistsPaidOption('balls'),
        lighting: getValueWhereExistsPaidOption('lighting'),
        shower: getValueWhereExistsPaidOption('showers'),
        changingRooms: getValueWhereExistsPaidOption('changingRooms'),
        manishki: getValueWhereExistsPaidOption('manishki')
      }
    }
  },
  async created () {
    await this.fetchInitialData()
  },
  methods: {
    async fetchInitialData () {
      try {
        const id = this.$route.params.id
        const { data } = await this.$api.field.change(id)
        const changes = data?.data ?? {}
        this.setInitialData(changes)
      } catch (e) {
        console.log(e)
      }
    },
    setInitialData (data) {
      const setValueWhereExistsPaidOption = (propName, value) => {
        if (value === 'yes') {
          this.form[propName].radio = true
        } else if (value === 'no') {
          this.form[propName].radio = false
        } else if (!isNaN(parseInt(value))) {
          this.form[propName].radio = 'paid'
          this.form[propName].price = value
        }
      }

      setValueWhereExistsPaidOption('balls', data?.ball)
      setValueWhereExistsPaidOption('lighting', data?.lighting)
      setValueWhereExistsPaidOption('showers', data?.shower)
      setValueWhereExistsPaidOption('changingRooms', data?.changingRooms)
      setValueWhereExistsPaidOption('manishki', data?.manishki)

      this.form.coating = data?.coating
      this.form.studdedCleats = data?.studdedCleats
      this.form.paymentTransfer = data?.paymentByTransfer
      this.form.phone = data?.phone
      this.form.price = data?.price
      this.form.title = data?.title
    },
    async onSave () {
      if (this.v$.form.$invalid) {
        this.v$.form.$touch()
        return
      }

      try {
        const id = this.$route.params.id
        const res = await this.$api.field.change(id, this.requestBody)

        if (res.data.status === 'ok') {
          alert('Изменения успешно пременены.')
        } else {
          alert('Произошла ошибка. Не удалось сохранить изменения.')
        }
      } catch (e) {
        alert('Произошла ошибка. Не удалось сохранить изменения.')
        console.log(e)
      }
    }
  },
  validations () {
    return {
      form: {
        title: {
          required
        },
        price: {
          required
        },
        phone: {
          required,
          isCorrectly: function (val) {
            return val.length === 18
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  &-inputs {
    max-width: 500px;

    &__price {
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  .radio-wrappers {
    display: flex;
    flex-wrap: wrap;

    &__item {
      width: 200px;
      margin-right: 20px;
      margin-bottom: 20px;
      font-size: 14px;

      .price-input {
        background: #19191A;
        margin-top: 10px;
        width: 50%;
        height: 33px;
        font-size: 14px;

        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }

  .panel {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
